<template>
    <div>
        <v-card class="main-card rounded-lg pa-4 mb-4">
            <div class="d-flex align-center justify-space-between mb-3">
                <div class="d-flex align-center">
                    <v-icon color="primary" class="mr-2">mdi-clipboard-list</v-icon>
                    <h3 class="text-subtitle-1 font-weight-medium primary--text">
                        {{ project.activities_hours_by_operator.length }} Attività nel progetto
                        <span class="grey--text text--lighten-1 font-weight-regular ml-2">{{ project.name }}</span>
                    </h3>
                </div>
            </div>

            <v-data-table
                :headers="activitiesHeaders"
                :items="project.activities_hours_by_operator"
                item-key="name"
                show-expand
                light
                class="elevation-0 activity-table"
                hide-default-footer
                :items-per-page="20"
                :expanded.sync="expandedItems"
            >
            <template #header.alert>
              <div class="d-flex justify-center align-center">
                <v-icon small color="primary">mdi-bell-alert</v-icon>
              </div>
            </template>
            <template #item.alert="{ item }">
              <v-icon v-if="item.alert" small color="error">
                mdi-bell-badge-outline
              </v-icon>
            </template>
            <template #expanded-item="{ headers, item }">
                <detail-project-activities-product
                  :col-span="headers.length"
                  :products="project.products_by_activity[item.id] || []"
                  :operators="operators"
                  @taskSaved="$emit('taskSaved')" />
            </template>
        </v-data-table>
        </v-card>
    </div>
</template>

<script>
import DetailProjectActivitiesProduct from "./DetailProjectActivitiesProduct.vue"

export default {
    components: {DetailProjectActivitiesProduct},
    props: {
        project: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            expanded: [],
            expandedItems: [],
        };
    },
    mounted() {
      console.log(this.project)
    },
  computed: {
        activitiesHeaders() {
            const items = this.operators.reduce((array, item) => {
                array.push(
                    {text: item.full_name, value: `${item.id}`, class: "primary--text font-weight-medium text-center", align: 'center'},
                )
                return array
            }, []);
            return [].concat(
                [
                  {text: '', align: 'center', sortable: false, value: 'alert', class: "primary--text font-weight-medium", width: '60px'},
                  {text: 'Attività', align: 'start', sortable: false, value: 'name', class: "primary--text font-weight-medium"},
                ],
                items,
                [{text: '', value: 'data-table-expand', sortable: false, width: '50px'}]
            );
        },
        operators() {
            // Filtra gli operatori in base ai permessi dell'utente
            const allOperators = this.project.operators;

            // Admin e HEAD possono vedere tutti gli operatori
            if (this.$store.getters.isAdmin || this.$store.getters.isHead) {
                return allOperators;
            }

            // Altri ruoli vedono solo se stessi
            return allOperators.filter(operator => operator.id === this.$store.state.user.id);
        }
    }
}
</script>
<style>
/* Stile per la tabella principale */
.activity-table {
    border: 1px solid rgba(0, 0, 0, 0.05) !important;
    border-radius: 8px !important;
    overflow: hidden !important;
    table-layout: fixed !important;
    border-spacing: 0 8px !important; /* Spaziatura tra le righe */
}

.activity-table table {
    width: 100% !important;
    table-layout: fixed !important;
}

.activity-table .v-data-table__wrapper {
    border-radius: 8px !important;
}

.activity-table thead th {
    background-color: white !important;
    color: var(--v-primary-base) !important;
    font-weight: 600 !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1) !important;
    height: 48px !important;
    vertical-align: middle !important;
    line-height: 1 !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}

.activity-table tbody tr {
    border-bottom: 2px solid rgba(0, 0, 0, 0.1) !important;
    min-height: 64px !important; /* Altezza maggiore per le righe delle attività */
    height: 64px !important;
    margin-bottom: 4px !important;
}

/* Colori alternati per le righe delle attività */
.activity-table tbody tr:nth-child(even) {
    background-color: rgba(248, 250, 254, 0.7) !important;
}

.activity-table tbody tr:nth-child(odd) {
    background-color: white !important;
}

.activity-table tbody tr.v-data-table__expanded-row {
    border-bottom: none !important;
}

.activity-table tbody tr.v-data-table__expanded-row td {
    padding: 0 !important;
    border-bottom: none !important;
}

.activity-table tbody tr.v-data-table__expanded {
    background-color: #f5f5f5 !important;
    min-height: 56px !important; /* Mantiene l'altezza quando espansa */
    height: 56px !important;
}

/* Assicura che le celle delle attività mantengano la loro altezza */
.activity-table tbody tr.v-data-table__expanded td {
    vertical-align: middle !important;
    min-height: 56px !important;
    height: 56px !important;
}

/* Stile per la riga espansa */
.v-data-table tr.v-data-table__expanded.v-data-table__expanded__content {
    box-shadow: none !important;
    border-top: none !important;
    display: table-row !important;
}

.v-data-table tr.v-data-table__expanded.v-data-table__expanded__content td {
    padding: 0 !important;
    display: table-cell !important;
}

/* Stile per le righe della tabella */
.v-data-table tbody tr {
    transition: background-color 0.2s ease;
}

/* Hover solo per le righe principali delle attività, NON per quelle espanse */
.activity-table tbody tr:not(.v-data-table__expanded):not(.v-data-table__expanded__content):hover {
    background-color: rgba(25, 118, 210, 0.04) !important;
}

.activity-table tbody tr:not(.v-data-table__expanded):not(.v-data-table__expanded__content):hover td:first-child {
    border-left: 4px solid #1976d2 !important;
}

.v-data-table tbody td {
    font-size: 0.875rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    height: 48px !important;
    vertical-align: middle !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}

.v-data-table thead th {
    font-size: 0.875rem;
    background-color: white !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

/* Forza SOLO la tabella principale delle attività a mantenere la larghezza completa */
.activity-table {
    width: 100% !important;
}

.activity-table > .v-data-table__wrapper > table {
    width: 100% !important;
    table-layout: auto !important;
}

/* Forza le righe della tabella principale a mantenere la larghezza completa quando espanse */
.activity-table > .v-data-table__wrapper > table > tbody > tr {
    width: 100% !important;
}

.activity-table > .v-data-table__wrapper > table > tbody > tr.v-data-table__expanded {
    width: 100% !important;
}

.activity-table > .v-data-table__wrapper > table > tbody > tr > td {
    width: auto !important;
}

/* Stili per il contenuto espanso - NON influenza le tabelle interne */
.activity-table > .v-data-table__wrapper > table > tbody > tr.v-data-table__expanded.v-data-table__expanded__content {
    width: 100% !important;
}

.activity-table > .v-data-table__wrapper > table > tbody > tr.v-data-table__expanded.v-data-table__expanded__content > td {
    width: 100% !important;
    padding: 0 !important;
}

/* Assicura che le tabelle interne (prodotti) mantengano il loro layout normale */
.activity-table .product-table {
    table-layout: fixed !important;
}

.activity-table .product-table table {
    table-layout: fixed !important;
    width: 100% !important;
}

/* Rimuove le barre di scorrimento antiestetiche */
.activity-table .v-data-table__wrapper {
    overflow-x: visible !important;
    overflow-y: visible !important;
}

.activity-table .product-table .v-data-table__wrapper {
    overflow-x: visible !important;
    overflow-y: visible !important;
}

/* Stili per evidenziare i livelli di espansione */

/* PRIMO LIVELLO: Riga attività espansa - Contrasto migliorato */
.activity-table tbody tr.v-data-table__expanded {
    background: linear-gradient(90deg, #bbdefb 0%, #e1f5fe 100%) !important;
    border-left: 6px solid #1976d2 !important;
    box-shadow: 0 3px 12px rgba(25, 118, 210, 0.2) !important;
    border-top: 2px solid rgba(25, 118, 210, 0.3) !important;
    border-bottom: 2px solid rgba(25, 118, 210, 0.3) !important;
}

.activity-table tbody tr.v-data-table__expanded td {
    border-bottom: 2px solid rgba(25, 118, 210, 0.4) !important;
    font-weight: 600 !important;
}

/* SECONDO LIVELLO: Contenuto espanso (tabella prodotti) - Contrasto migliorato */
.activity-table tr.v-data-table__expanded.v-data-table__expanded__content {
    background: #e3f2fd !important;
    border-left: 6px solid #1976d2 !important;
    border-right: 2px solid rgba(25, 118, 210, 0.2) !important;
    border-bottom: 3px solid rgba(25, 118, 210, 0.3) !important;
    position: relative !important;
    box-shadow: inset 0 0 8px rgba(25, 118, 210, 0.1) !important;
}

.activity-table tr.v-data-table__expanded.v-data-table__expanded__content::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 6px;
    background: linear-gradient(180deg, #1976d2 0%, #42a5f5 50%, #1976d2 100%);
}

/* Stile per la card contenitore dei prodotti - Contrasto migliorato */
.activity-table .product-table {
    background: white !important;
    border-radius: 0 !important; /* Rimosso border-radius per eliminare margini */
    margin: 0 !important; /* Rimosso tutti i margini */
    box-shadow: none !important; /* Rimosso shadow temporaneamente */
    border: none !important; /* Rimosso border temporaneamente */
    overflow: visible !important; /* Cambiato da hidden a visible */
}

/* FORZA la rimozione di TUTTE le barre di scorrimento */
.activity-table .product-table ::-webkit-scrollbar {
    display: none !important;
}

.activity-table .product-table {
    -ms-overflow-style: none !important;
    scrollbar-width: none !important;
}

.activity-table .product-table * {
    overflow-x: visible !important;
}

/* Header della tabella prodotti */
.activity-table .product-table .v-data-table__wrapper {
    border-radius: 12px !important;
}

/* Assicura che le tabelle si adattino senza overflow */
.activity-table table,
.activity-table .product-table table {
    min-width: auto !important;
    width: 100% !important;
}

.activity-table .v-data-table,
.activity-table .product-table .v-data-table {
    overflow: visible !important;
}

.activity-table .product-table thead {
    background: linear-gradient(90deg, #e8f5e8 0%, #f1f8e9 100%) !important;
}

.activity-table .product-table thead th {
    background: transparent !important;
    border-bottom: 3px solid rgba(25, 118, 210, 0.4) !important;
    font-weight: 700 !important;
    color: #1565c0 !important;
    text-transform: uppercase !important;
    letter-spacing: 0.5px !important;
}

/* Migliora la leggibilità del font nelle tabelle */
.activity-table tbody td {
    font-weight: 600 !important; /* Bold per le attività principali */
    font-family: 'Poppins', sans-serif !important;
    font-size: 0.9rem !important;
    border-left: 3px solid transparent !important;
    transition: all 0.2s ease !important;
}

.activity-table .product-table tbody td {
    font-weight: 500 !important; /* Meno bold per i prodotti */
    font-family: 'Poppins', sans-serif !important;
}

.activity-table thead th,
.activity-table .product-table thead th {
    font-weight: 600 !important;
    font-family: 'Poppins', sans-serif !important;
}

/* Testo nei chip e badge */
.activity-table .v-chip,
.activity-table .product-table .v-chip {
    font-weight: 500 !important;
}

/* Testo nei pulsanti */
.activity-table .v-btn,
.activity-table .product-table .v-btn {
    font-weight: 500 !important;
}
</style>
